/**
 * Created by Adam on 06/06/2017.
 */

if (window['jQuery']) {
    window.jQuery(function ($) {
        function closeBanner() {
            if (cookieBanner.hasClass('share-stick-Bottom')){
                cookieBanner.css({"transition":"max-height 0.5s ease-out",'max-height':'0'});
            }
            else {
              cookieBanner.css({'transform': 'translateY(100%)'});
            }
            trackCTA('cookie_banner_click');
            setTimeout(function () {
                cookieBanner.remove();
            }, 500);
            var footer=$('#footer'),
                goUpButton = $('#goUpButton'),
                fabButton = $('#fab-social-button');
            if (footer){
                footer.css({"margin-bottom":"0"});
            }
          if (goUpButton && goUpButton.length>0){
            goUpButton.removeClass('cookie-banner-on');
          }
          if (fabButton && fabButton.length>0){
            fabButton.removeClass('cookie-banner-on');
          }

        }

        var cookieBanner = $('#cookie-policy-banner');

        if (cookieBanner.length > 0) {
            var bannerCookie = getCookie('TCTCookiePolicyBanner');
            //Check if the user saw the cookie banner
            if (bannerCookie) {
                cookieBanner.remove();
            }
            else {
                var footer=$('#footer');
                if (footer){
                    footer.css({"margin-bottom":"60px"});
                }
                var cookieClearButton = $('#cookie-clear-button', cookieBanner),
                    cookieLink = $('#cookie-banner-link', cookieBanner),
                    goUpButton = $('#goUpButton'),
                    fabButton = $('#fab-social-button');

                trackCTANoInteraction('cookie_banner_appear');
                setCookie('TCTCookiePolicyBanner', true, 365);
                cookieBanner.css({'transform': 'translateY(0)'});
                cookieClearButton.on('click', closeBanner);
                cookieLink.on('click', closeBanner);
                if (goUpButton && goUpButton.length>0){
                  goUpButton.addClass('cookie-banner-on');
                }
              if (fabButton && fabButton.length>0){
                fabButton.addClass('cookie-banner-on');
              }

            }
        }
    });
}